export default __webpack_public_path__ + "static/2-2c0650539e5768d235b04c5e82dd16a2.jpg";